export default "__VITE_ASSET__zY3AmuGo__"